// @flow

import React from 'react';

import { STORE_INFO } from '../path/storePath';
import { getCurrentPcId } from './urlUtils';

export const bestRetailerUrl = (codstr: number, pcId?: number) => `${STORE_INFO}?store=${codstr}&mall=${pcId || getCurrentPcId()}`;

export const bestRetailerBPUrl = (codstr: number, pcId?: number, leaseId?: number) =>
  `${bestRetailerUrl(codstr, pcId)}${leaseId ? `&bp=${leaseId}` : ''}`;
